export interface TeamMember {
  id: string
  name: string
  role: string
  bio: string
  initials: string
  color: string
}

export const leadership: TeamMember[] = [
  {
    id: 'l1',
    name: 'André Felipe',
    role: 'Diretor Comercial e Relacionamento com o Cliente',
    bio: 'Mais de 20 anos de experiência em telecom e segurança eletrônica, atuando na implementação de projetos e gestão de equipes. Acumulou muitas experiências desenvolvendo projetos além do Brasil, em Angola.',
    initials: 'AF',
    color: 'bg-cyan-600',
  },
  {
    id: 'l2',
    name: 'Renan Carlos',
    role: 'Diretor de Operações e Inovação',
    bio: 'Com grande experiência adquirida ao longo de mais de 22 anos de carreira em TI, dirige com objetividade e dinamismo as operações e implementações de projetos executados por nossa empresa.',
    initials: 'RC',
    color: 'bg-amber-600',
  },
]

export interface Milestone {
  year: string
  title: string
  description: string
}

export const milestones: Milestone[] = [
  { year: '2009', title: 'Fundação da empresa', description: 'Início das operações com foco em videovigilância para pequenas empresas.' },
  { year: '2013', title: 'Expansão para controle de acesso', description: 'Lançamento da linha de soluções de controle de acesso e biometria.' },
  { year: '2016', title: 'Certificação ISO 9001', description: 'Conquista da certificação de qualidade em gestão de processos.' },
  { year: '2019', title: 'Novas unidades regionais', description: 'Abertura de escritórios em três novos estados para atendimento nacional.' },
  { year: '2022', title: 'Plataforma de monitoramento em nuvem', description: 'Lançamento de plataforma proprietária de monitoramento integrado.' },
  { year: '2024', title: 'Mais de 500 projetos entregues', description: 'Consolidação como referência nacional em consultoria de segurança tecnológica.' },
]
